import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable, tap } from "rxjs";

import { StorageService } from "@coin-depo-core/storage";
import { AUTH_SERVICE_TOKEN, AuthFacade } from "@coin-depo-core/auth";
import { GovernanceFacade } from "@coin-depo-core/governance";
import { LanguageFacade } from "@coin-depo-i18n";
import { ApiService } from "@coin-depo/http";

import { GovernanceResponse } from "@coin-depo-types";

@Injectable({
    providedIn: 'root',
  })
export class GovernanceService implements GovernanceFacade {
    protected storageKeyBanner = 'governanceBanner';
    protected isBannerClosed$ = new BehaviorSubject<boolean>(
        this.storage.get(this.storageKeyBanner, false)
    );
    cachedIsBannerClosed$ = this.isBannerClosed$.asObservable();


    protected storageKeyGovernanceState = 'governanceState';
    protected governanceState$ = new BehaviorSubject<GovernanceResponse>(
        this.storage.get(this.storageKeyGovernanceState, null)
    );
    cachedGovernanceState$ = this.governanceState$.asObservable();

    isLoading$ = new BehaviorSubject<boolean>(false);

    constructor(
        @Inject(AUTH_SERVICE_TOKEN) private auth: AuthFacade,
        private storage: StorageService,
        private api: ApiService,
        private translate: LanguageFacade,
    ) {}

    getGovernanceGeneral(): Observable<GovernanceResponse> {
        this.isLoading$.next(true);
        const userData = this.auth.userData;

        const data = {
            client_token: this.auth.accessToken,
            username: userData.email,
            lang: this.translate.currentLang,
        };

        return this.api.getGovernanceGeneral(data).pipe(
            tap(res => {
                if (res.status == 'success') {
                    this.setGovernanceState(res);
                };
            })
        );
    }

    setGovernanceVote(answer_ids?: number): Observable<GovernanceResponse> {
        if (!answer_ids) return this.governanceState$;

        this.isLoading$.next(true);

        const userData = this.auth.userData;
        const data = {
            client_token: this.auth.accessToken,
            username: userData.email,
            lang: this.translate.currentLang,
            answer_ids: answer_ids
        };

        return this.api.setGovernanceVote(data).pipe(
            tap(res => {
                if (res.status == 'success') {
                    this.setGovernanceState(res);
                };
            })
        )
    }

    setGovernanceState(state: GovernanceResponse) {
        delete state.warnings;
        delete state.parent_id;
        delete state.closed_at;
        delete state.final_results_cid;
        delete state.final_results_ots;

        this.governanceState$.next(state);
        this.storage.set(this.storageKeyGovernanceState, state);

        this.isLoading$.next(false);
    }

    getGovernanceStateSnapshot(): GovernanceResponse | null {
        return this.governanceState$.value;
    }

    closeBanner() {
        this.isBannerClosed$.next(true);
        this.storage.set(this.storageKeyBanner, true);
    }
}